import { useEffect, useState } from 'react';
import { Box, Button, Typography, Grid } from "@mui/material";
import NotFound from "./notfound";
import { Link, useParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { orgClicked, showloader, transactionClicked, transactionDetail } from "../store/gloabalState";
import { getOrgsDetails, getTransactionsDetail, getDownloadDoc } from '../services/httpCalls';
import { DateConvert } from '../utils/dateConverter';
import TransactionDownloadDocs from '../components/TransactionDownloadDocs';
import { saveAs } from 'file-saver';

const InwardTransactionDetail = () => {

    // local states
    const [users, setUser] = useState();
    const [orgID, setOrgId] = useState();
    const [userID, setUserID] = useState();
    const [showNotFound, setShowNotFound] = useState(false);
    const [hidePreviewEsign, setHidePreviewEsign] = useState(false);

    // global states

    // values

    // setter/updater
    const setShowLoader = useSetRecoilState(showloader);

    // states
    const [orgDetails, setOrgDetails] = useRecoilState(orgClicked);
    const [transactionId, setTransactionId] = useRecoilState(transactionClicked);
    const [transactionDetails, setTransactionDetails] = useRecoilState(transactionDetail)

    // constants/binders
    const params = useParams();

    const downloadDoc = async () => {
        if (transactionId) {
          getDownloadDoc(transactionId).then((res) => {
            saveAs(res.message, "download.zip");
          });
        }
      };

    const getOrgDetails = async (userID, orgID) => {
        getOrgsDetails(orgID).then((res) => {
          setOrgDetails(res);
          let userList = res?.userList;
          userList?.forEach((value) => {
            if (value.id === userID) {
              setUser(value);
            }
          });
          setShowLoader(false);
        });
      };

      useEffect(() => {
        async function getTransactionDetail(transactionId) {
          setShowLoader(true);
          if (transactionId) {
            getTransactionsDetail(transactionId)
              .then((res) => {
                setTransactionDetails(res);
                if (res.docEsignStatus === "SIGNED") {
                  setHidePreviewEsign(true);
                }
                setShowNotFound(false);
                setOrgId(res?.organisationId);
                setUserID(res?.userId);
                getOrgDetails(res?.userId, res?.organisationId);
              })
              .catch((error) => {
                if (error.code === "ERR_BAD_REQUEST") {
                  setShowNotFound(true);
                }
                setShowLoader(false);
              });
          } else {
            let url = window.location.pathname;
            let id = params.id;
            url = url.split("/");
            url = url[3];
            setTransactionId(url);
            getTransactionsDetail(url);
          }
        }
        getTransactionDetail(params.id);
      }, [transactionId, params.id]);

      useEffect(() => {
        setTransactionId(params.id)     
      },[])

    return(
        <Box sx={{ padding: '1rem' }} >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                    variant="h5"
                    sx={{ paddingBottom: '1rem', fontWeight: 400 }}
                >
                    Details of Transaction ID (<b>{params.id}</b>)
                </Typography>
                { !showNotFound && (
                    <Button
                        variant="contained"
                        LinkComponent={Link}
                        to={`/updateinward/${params.id}`}
                        sx={{ marginLeft: "auto" }}
                        // TODO to be added later
                        // disabled={}
                    >
                        Edit
                    </Button>
                ) }
            </Box>
            { showNotFound ? (
                <NotFound/>
            ) : (
                <>
                <Grid item xs={5}>
                        <Box
                            sx={{
                            padding: ".5rem 0",
                            display: "flex",
                            alignItems: "center",
                        }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 400 }}>
                                Customer Details
                            </Typography>
                        </Box>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Customer Name:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.customerName
                                    ? transactionDetails.customerName
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Initiation Date:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.initiationDate
                                    ? DateConvert(transactionDetails?.initiationDate)
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Current State:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.stage 
                                    ? transactionDetails.stage
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Currency:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.invoice?.[0]?.currency_code
                                    ? transactionDetails?.invoice?.[0]?.currency_code
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Amount:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.invoice?.[0]?.amount
                                    ? transactionDetails?.invoice?.[0]?.amount
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Invoice Date:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.invoice?.[0]?.invoice_date
                                    ? transactionDetails?.invoice?.[0]?.invoice_date
                                    : "-"
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Ops Member Assigned:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.assignedOpsMember
                                    ? transactionDetails.assignedOpsMember
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Net INR Received:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.payout?.amount
                                    ? transactionDetails?.payout?.amount
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Files:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                <TransactionDownloadDocs downloadDoc={downloadDoc}/>   
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                UTR:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.utr
                                    ? transactionDetails.utr
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Commission Charges:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.miscellaneousCharges
                                    ? transactionDetails.miscellaneousCharges
                                    : '-'
                                }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                GST charges:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.gstAmount
                                    ? transactionDetails.gstAmount
                                    : "-"
                                }
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Grid 
                    item 
                    xs={5}
                    style={{ marginTop: '2rem' }}
                    >
                            <Box
                                sx={{
                                    padding: '0.5rem 0',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 400 }}
                                >
                                    Transaction Details
                                </Typography>
                            </Box>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Due Date/Propose Date:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.invoice?.[0]?.due_date_of_payment
                                    ? transactionDetails?.invoice?.[0]?.due_date_of_payment
                                    : '-'
                                }
                            </Typography>
                        </Box>          
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Purpose of Inward Transaction/Remittance:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.purposeCodeAsPerRBI
                                    ? transactionDetails.purposeCodeAsPerRBI
                                    : '-'
                                }
                            </Typography>
                        </Box>          
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                               Payer Name:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.partner?.legal_name
                                    ? transactionDetails.partner.legal_name
                                    : "-"
                                }
                            </Typography>
                        </Box>          
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Payer Nick Name:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.partner?.nickname
                                    ? transactionDetails.partner.nickname
                                    : '-'
                                }
                            </Typography>
                        </Box>          
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Payer Email:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.partner?.email
                                    ? transactionDetails?.partner?.email
                                    : ""
                                }
                            </Typography>
                        </Box>          
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Invoice Number:
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.invoice?.[0]?.reference_number
                                    ? transactionDetails?.invoice?.[0]?.reference_number
                                    : '-'
                                }
                            </Typography>
                        </Box>          
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                padding: '0.5rem 0',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                                Transaction Type(Goods/Service/Software):
                            </Typography>
                            <Typography
                                variant="p"
                                sx={{ fontWeight: 500, fontSize: 16, paddingLeft: "0.5rem" }}
                            >
                                {
                                    transactionDetails?.transactionType
                                    ? transactionDetails.transactionType
                                    : '-'
                                }
                            </Typography>
                        </Box>          
                    </Grid>

                </Grid>
                </>
            ) }
        </Box>
    )
}

export default InwardTransactionDetail;